import React, { useState, useEffect } from 'react'
import { Table, Icon, IconButton, Row, Col } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { budgetFormat } from '../../utils/formatterUtil'

export default function ExpertPaymentListTable({
  schema,
  loading,
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},

  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema?.values || [])
  }, [schema?.values])

  // console.log('schemaTable==>', schema)

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 50}
        data={tableData}
        style={{ marginTop: '20px' }}
      >
        <Column width={90} align="center" fixed="left">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={250}>
          <HeaderCell>ชื่อ-สกุล</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>
        <Column width={150}>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectId" />
        </Column>
        <Column minWidth={400} width={300} flexGrow={1}>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={150}>
          <HeaderCell>ธนาคาร</HeaderCell>
          <Cell dataKey="bankName" />
        </Column>
        <Column width={150}>
          <HeaderCell>เลขบัญชี</HeaderCell>
          <Cell dataKey="bankId" />
        </Column>
        <Column width={150}>
          <HeaderCell>จำนวนเงินเบิกจ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              return budgetFormat(rowData.disbursementAmount || 0)
            }}
          </Cell>
        </Column>
        <Column width={150}>
          <HeaderCell>สถานะ</HeaderCell>
          <Cell dataKey="status" />
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
